import { Attributes, LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class IssuerPagedLookup extends LookupBase {

    public issuerId: number = 0;

    public issuerName: string = "";

    public isAuthorised: boolean = false;

    public isPendingDelete: boolean = false;

    @Attributes.Display("Legal Entity Type")
    public legalEntityTypeName: string = "";

    // Client only properties / methods
}